// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Leetcode Wizard
 * Leetcode Wizard API Description
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ModelsResponseDto
 */
export interface ModelsResponseDto {
    /**
     *
     * @type {Array<object>}
     * @memberof ModelsResponseDto
     */
    models: Array<object>;
    /**
     *
     * @type {Array<string>}
     * @memberof ModelsResponseDto
     */
    textTextModelIds: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof ModelsResponseDto
     */
    textImageModelIds: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof ModelsResponseDto
     */
    structuredOutputModelIds: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof ModelsResponseDto
     */
    recommended: Array<string>;
    /**
     *
     * @type {string}
     * @memberof ModelsResponseDto
     */
    defaultModelId: string;
    /**
     *
     * @type {object}
     * @memberof ModelsResponseDto
     */
    modelReplacements: object;
    /**
     *
     * @type {number}
     * @memberof ModelsResponseDto
     */
    count: number;
}

/**
 * Check if a given object implements the ModelsResponseDto interface.
 */
export function instanceOfModelsResponseDto(value: object): value is ModelsResponseDto {
    if (!('models' in value) || value['models'] === undefined) return false;
    if (!('textTextModelIds' in value) || value['textTextModelIds'] === undefined) return false;
    if (!('textImageModelIds' in value) || value['textImageModelIds'] === undefined) return false;
    if (!('structuredOutputModelIds' in value) || value['structuredOutputModelIds'] === undefined)
        return false;
    if (!('recommended' in value) || value['recommended'] === undefined) return false;
    if (!('defaultModelId' in value) || value['defaultModelId'] === undefined) return false;
    if (!('modelReplacements' in value) || value['modelReplacements'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function ModelsResponseDtoFromJSON(json: any): ModelsResponseDto {
    return ModelsResponseDtoFromJSONTyped(json, false);
}

export function ModelsResponseDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ModelsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        models: json['models'],
        textTextModelIds: json['textTextModelIds'],
        textImageModelIds: json['textImageModelIds'],
        structuredOutputModelIds: json['structuredOutputModelIds'],
        recommended: json['recommended'],
        defaultModelId: json['defaultModelId'],
        modelReplacements: json['modelReplacements'],
        count: json['count'],
    };
}

export function ModelsResponseDtoToJSON(value?: ModelsResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        models: value['models'],
        textTextModelIds: value['textTextModelIds'],
        textImageModelIds: value['textImageModelIds'],
        structuredOutputModelIds: value['structuredOutputModelIds'],
        recommended: value['recommended'],
        defaultModelId: value['defaultModelId'],
        modelReplacements: value['modelReplacements'],
        count: value['count'],
    };
}
